import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import { useSettingsContext } from "../../components/settings";
import Main from "./Main";
import Header from "./header";
import NavMini from "./nav/NavMini";
import NavVertical from "./nav/NavVertical";
import NavHorizontal from "./nav/NavHorizontal";
import { useAuthContext } from "src/auth/useAuthContext";
import { useDispatch } from "react-redux";
import { updateVenueOnlineStatus } from "src/redux/slices/venue";

export default function DashboardLayout() {
  const { themeLayout } = useSettingsContext();
  const { user, logout } = useAuthContext();
  let dispatch = useDispatch();
  const isDesktop = useResponsive("up", "lg");
  const [open, setOpen] = useState(false);
  const isNavHorizontal = themeLayout === "horizontal";
  const isNavMini = themeLayout === "mini";
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [isVenueOnline, setIsVenueOnline] = useState(user?.venue?.isOnline ?? false);

  const handleVenueOnlineStatusChange = async (e) => {
    const isChecked = e.target.checked;
    setIsVenueOnline(isChecked);
    await dispatch(updateVenueOnlineStatus(user.venueId, isChecked, user?.photoURL, user?.receiptURL));
  };

  const renderNavVertical = (
    <NavVertical
      openNav={open}
      onCloseNav={handleClose}
      isVenueOnline={isVenueOnline}
      handleVenueOnlineStatusChange={handleVenueOnlineStatusChange}
    />
  );

  if (isNavHorizontal) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        {isDesktop ? <NavHorizontal /> : renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </>
    );
  }

  if (isNavMini) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        <Box
          sx={{
            display: { lg: "flex" },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? (
            <NavMini isVenueOnline={isVenueOnline} handleVenueOnlineStatusChange={handleVenueOnlineStatusChange} />
          ) : (
            renderNavVertical
          )}

          <Main>
            <Outlet />
          </Main>
        </Box>
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: "flex" },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </Box>
    </>
  );
}
